import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './modules/auth/login/login.component';
import { RegistryComponent } from './modules/auth/registry/registry.component';

import { GlosarioEntidadComponent } from './modules/glosario/glosario-entidad/glosario-entidad.component';

import { GestionExpedientesComponent } from './modules/expediente/gestion-expedientes/gestion-expedientes.component';
import { HomeComponent } from './modules/home/home.component';
import { AvanceProcesalComponent } from './modules/expediente/avance-procesal/avance-procesal.component';
import { DetalleSuperfinancieraComponent } from './modules/expediente/detalle-superfinanciera/detalle-superfinanciera.component';
import { DetalleSupersociedadesComponent } from './modules/expediente/detalle-supersociedades/detalle-supersociedades.component';
import { DetalleDndaComponent } from './modules/expediente/detalle-dnda/detalle-dnda.component';
import { DetalleSicComponent } from './modules/expediente/detalle-sic/detalle-sic.component';
import { DetalleDimarComponent } from './modules/expediente/detalle-dimar/detalle-dimar.component';
import { DetalleIcaComponent } from './modules/expediente/detalle-ica/detalle-ica.component';
import { DetalleSupersaludComponent } from './modules/expediente/detalle-supersalud/detalle-supersalud.component';
import { ProcesosDimarComponent } from './modules/visualizacion/procesos-dimar/procesos-dimar.component';
import { ProcesosDndaComponent } from './modules/visualizacion/procesos-dnda/procesos-dnda.component';
import { authGuard } from './services/guard/auth.guard';
import { ConfigurarCuentaComponent } from './modules/configuracion-cuenta/configurar-cuenta/configurar-cuenta.component';
import { ConfigurarCuentaAdministrativaComponent } from './modules/configuracion-cuenta/configurar-cuenta-administrativa/configurar-cuenta-administrativa.component';
import { CambiarContraseniaComponent } from './modules/auth/cambiar-contrasenia/cambiar-contrasenia.component';
import { DetalleAvanceProcesalComponent } from './modules/expediente/detalle-avance-procesal/detalle-avance-procesal.component';
import { AnexosAvanceProcesalComponent } from './modules/expediente/anexos-avance-procesal/anexos-avance-procesal.component';
import { ProcesosSicComponent } from './modules/visualizacion/procesos-sic/procesos-sic.component';
import { ProcesosSupersaludComponent } from './modules/visualizacion/procesos-supersalud/procesos-supersalud.component';
import { ProcesosSuperfinancieraComponent } from './modules/visualizacion/procesos-superfinanciera/procesos-superfinanciera.component';
import { ProcesosIcaComponent } from './modules/visualizacion/procesos-ica/procesos-ica.component';
import { PreguntasFrecuentesComponent } from './modules/preguntas-frecuentes/preguntas-frecuentes.component';
import { ListaAdministradoresComponent } from './modules/administracion-usuarios/lista-administradores/lista-administradores.component';
import { CrearAdministradorComponent } from './modules/administracion-usuarios/crear-administrador/crear-administrador.component';
import { ModificarAdministradorComponent } from './modules/administracion-usuarios/modificar-administrador/modificar-administrador.component';
import { VisualizarAdministradorComponent } from './modules/administracion-funcional/visualizar-administrador/visualizar-administrador.component';

import { RestablecerContraseniaComponent } from './modules/auth/restablecer-contrasenia/restablecer-contrasenia.component';
import { ProcesosSupersociedadesMercantilesComponent } from './modules/visualizacion/procesos-supersociedades-mercantiles/procesos-supersociedades-mercantiles.component';
import { DetalleSupersociedadesMercantilesComponent } from './modules/expediente/detalle-supersociedades-mercantiles/detalle-supersociedades-mercantiles.component';
import { ValidarUsuarioComponent } from './modules/auth/validar-usuario/validar-usuario.component';
import { FormulariosEnviadosComponent } from './modules/integrador/formularios-enviados/formularios-enviados.component';
import { GestionPlantillasCorreoComponent } from './modules/administracion-usuarios/gestion-plantillas-correo/gestion-plantillas-correo.component';

import { GestionEntidadesComponent } from './modules/administracion-usuarios/gestion-entidades/gestion-entidades.component';
import { GestionAlertasComponent } from './modules/administracion-usuarios/gestion-alertas/gestion-alertas.component';
import { DashboardComponent } from './modules/administracion-usuarios/dashboard/dashboard.component';
import { EncuestaSatisfaccionComponent } from './modules/encuestas/encuesta-satisfaccion/encuesta-satisfaccion.component';
import { MetricasEntidadComponent } from './modules/metricas-entidad/metricas-entidad.component';
import { GestionExpedienteAdministradorComponent } from './modules/expediente/gestion-expediente-administrador/gestion-expediente-administrador.component';
import { ExpedientesSegundaInstanciaComponent } from './modules/expediente/expedientes-segunda-instancia/expedientes-segunda-instancia.component';
import { GestionManualComponent } from './modules/integrador/gestion-manual/gestion-manual.component';
import { GestionPermisosExpedienteComponent } from './modules/expediente/gestion-permisos-expediente/gestion-permisos-expediente.component';
import { AdministracionEncuestasComponent } from './modules/encuestas/administracion-encuestas/administracion-encuestas.component';
import { ResumenGeneralComponent } from './modules/visualizacion/resumen-general/resumen-general.component';
import { ProcesosSupersociedadesInsolvenciaComponent } from './modules/visualizacion/procesos_supersociedades_insolvencia/procesos-supersociedades-insolvencia.component';
import { ParametrizacionEntidadesComponent } from './modules/parametrizacion-entidades/parametrizacion-entidades.component';
import { GestionGlosarioComponent } from './modules/administracion-usuarios/gestion-glosario/gestion-glosario.component';
import { GestionPreguntasFrecuentesComponent } from './modules/administracion-usuarios/gestion-preguntas-frecuentes/gestion-preguntas-frecuentes.component';
import { GestionInteroperabilidadComponent } from './modules/administracion-usuarios/gestion-interoperabilidad/gestion-interoperabilidad.component';
import { ValidacionDocumentosComponent } from "./modules/validacion-documentos/validacion-documentos.component";
import { GestionParametrizacionComponent } from './modules/administracion-usuarios/gestion-parametrizacion/gestion-parametrizacion.component';
import { EdicionDocumentoAdjuntoComponent } from './modules/administracion-usuarios/edicion-documento-adjunto/edicion-documento-adjunto.component';
import { IngresarCorreoOtpComponent } from "./modules/otp/ingresar-correo-otp/ingresar-correo-otp.component";
import { VerificarCodigoOtpComponent } from "./modules/otp/verificar-codigo-otp/verificar-codigo-otp.component";
import { VisualizarDocumentosComponent } from "./modules/otp/visualizar-documentos/visualizar-documentos.component";
import { expedienteGuard } from './services/guard/expediente.guard';
import { admFuncionalLiderGuard } from './services/guard/adm.funcional.lider.guard';
import {
  DetalleSupersociedadesInsolvenciaComponent
} from "./modules/expediente/supersociedades-insolvencia/detalle-supersociedades-insolvencia/detalle-supersociedades-insolvencia.component";
import {
  DetalleProcesoInsolvenciaComponent
} from "./modules/expediente/supersociedades-insolvencia/detalle-proceso-insolvencia/detalle-proceso-insolvencia.component";
import { LoginAdminComponent } from './modules/auth/login-admin/login-admin.component';
import { tramiteGuard } from './services/guard/tramite.guard';
import { GestionEventosEntidadComponent } from './modules/administracion-usuarios/gestion-eventos-entidad/gestion-eventos-entidad.component';
import { TableroResumenCiudadanoComponent } from './modules/administracion-usuarios/tablero-resumen-ciudadano/tablero-resumen-ciudadano.component';
import { AutenticacionDigitalComponent } from './modules/auth/autenticacion-digital/autenticacion-digital.component';
import { RegistroEmpresaComponent } from './modules/auth/registro-empresa/registro-empresa.component';
import { PasosSeguirComponent } from './modules/auth/pasos-seguir/pasos-seguir.component';
import { CredencialesDatosAdicionalesEmpresaComponent } from './modules/auth/credenciales-datos-adicionales-empresa/credenciales-datos-adicionales-empresa.component';
import { UsuariosGestoresComponent } from "./modules/empresas/usuarios-gestores/usuarios-gestores.component";
import {
  AdministracionSolicitudesPJComponent
} from "./modules/administracion-funcional/administracion-solicitudes-pj/administracion-solicitudes-pj.component";
import { RestablecerContraseniaEmpresaComponent } from './modules/auth/restablecer-contrasenia-empresa/restablecer-contrasenia-empresa.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { breadcrumb: 'Login' },
  },
  {
    path: 'loginAdmin',
    component: LoginAdminComponent,
    data: { breadcrumb: 'Login' },
  },
  {
    path: 'restablecer-contrasenia/:usuario-id',
    component: RestablecerContraseniaComponent,
    data: { breadcrumb: 'Restablecer contraseña' },
  },
  {
    path: 'restablecer-contrasenia-empresa/:usuario-id',
    component: RestablecerContraseniaEmpresaComponent,
    data: { breadcrumb: 'Restablecer contraseña' },
  },
  {
    path: 'cambiar-contrasenia/:token',
    component: CambiarContraseniaComponent,
    data: { breadcrumb: 'Cambiar contraseña' },
  },
  {
    path: 'cambiar-contrasenia',
    component: CambiarContraseniaComponent,
    data: { breadcrumb: 'Cambiar contraseña' },
  },
  {
    path: 'validacion-documentos',
    component: ValidacionDocumentosComponent,
    data: { breadcrumb: 'Validación de documentos' },
  },
  {
    path: 'ingreso-opt/:id',
    component: IngresarCorreoOtpComponent,
    data: { breadcrumb: 'Ingreso OTP' },
  },
  {
    path: 'verificar-otp',
    component: VerificarCodigoOtpComponent,
    data: { breadcrumb: 'Verificar OTP' },
  },
  {
    path: 'visualizar-documentos',
    component: VisualizarDocumentosComponent,
    canActivate: [tramiteGuard],
    data: { breadcrumb: 'Visualizar Documentos' },
  },
  {
    path: 'validar-usuario',
    component: ValidarUsuarioComponent,
    data: { breadcrumb: 'Validar usuario' },
  },
  {
    path: 'autenticacion-digital',
    component: AutenticacionDigitalComponent,
    data: { breadcrumb: 'Autenticación Ciudadano Digital' },
  },
  {
    path: 'registro',
    component: RegistryComponent,
    data: { breadcrumb: 'Registro' },
  },
  {
    path: 'registroEmpresa',
    component: RegistroEmpresaComponent,
    data: { breadcrumb: 'Registro empresa' },
  },
  {
    path: 'pasos-seguir',
    component: PasosSeguirComponent,
    data: { breadcrumb: '' },
  },
  {
    path: 'credenciales-empresa',
    component: CredencialesDatosAdicionalesEmpresaComponent,
    data: { breadcrumb: '' },
  },
  {
    path: 'encuesta/:id-encuesta',
    component: EncuestaSatisfaccionComponent,
    data: { breadcrumb: 'Encuesta' },
  },
  {
    path: '',
    data: { breadcrumb: 'miga-pan.inicio' },
    canActivate: [authGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [authGuard],
        data: { breadcrumb: '' },
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.dashboard' },
      },
      {
        path: 'usuarios-funcionales',
        component: ListaAdministradoresComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.usuarios-funcionales' },
      },
      {
        path: 'gestion-docs_justino',
        component: GestionParametrizacionComponent, // TODO reemplazar por componente relacionado
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.gestion-plantillas-JUSTINO' },
      },
      {
        path: 'gestion-parametrizacion',
        component: GestionParametrizacionComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.gestion-parametros' },
      },
      {
        path: 'gestion-glosario',
        component: GestionGlosarioComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.gestion-glosario' },
      },
      {
        path: 'edicion-documento-adjunto',
        component: EdicionDocumentoAdjuntoComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.edicion-documento-adjunto' },
      },
      {
        path: 'gestion-preguntas-frecuentes',
        component: GestionPreguntasFrecuentesComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.gestion-glosario' },
      },
      {
        path: 'gestion-plantillas-correo',
        component: GestionPlantillasCorreoComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.gestion-plantillas-correo' },
      },
      {
        path: 'gestion-interoperabilidad',
        component: GestionInteroperabilidadComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.gestion-interoperabilidad' },
      },
      {
        path: 'gestion-entidades',
        component: GestionEntidadesComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.gestion-entidades' },
      },
      {
        path: 'gestion-alertas',
        component: GestionAlertasComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.gestion-alertas' },
      },
      {
        path: 'glosario-entidad',
        component: GlosarioEntidadComponent,
        data: { breadcrumb: 'miga-pan.glosario-entidad' },
      },
      {
        path: 'tramites',
        loadChildren: () =>
          import('./modules/tramites/tramites-routing.module').then(
            m => m.TramitesRoutingModule
          ),
        data: { breadcrumb: 'miga-pan.proceso' },
      },
      {
        path: 'expediente',
        data: { breadcrumb: 'miga-pan.expediente' },
        children: [
          {
            path: '',
            component: GestionExpedientesComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'miga-pan.gestion-expedientes' },
          },
          {
            path: 'gestion-entidad',
            component: GestionExpedienteAdministradorComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'miga-pan.gestion-expedientes-administrador' },
          },
          {
            path: 'gestion-permisos/:idExpediente/:radicado',
            component: GestionPermisosExpedienteComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'miga-pan.gestion-permisos-expedientes' },
          },
          {
            path: 'segunda-instancia',
            component: ExpedientesSegundaInstanciaComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'miga-pan.gestion-expedientes-segunda-instancia' },
          },
          {
            path: 'superfinanciera',
            data: { breadcrumb: 'Superfinanciera' },
            children: [
              {
                path: ':expedienteId/:usuarioId',
                component: DetalleSuperfinancieraComponent,
                canActivate: [authGuard, expedienteGuard],
                data: { breadcrumb: 'miga-pan.historico' },
              },
            ],
          },
          {
            path: 'supersociedades',
            data: { breadcrumb: 'Supersociedades' },
            children: [
              {
                path: ':expedienteId/:usuarioId',
                component: DetalleSupersociedadesComponent,
                canActivate: [authGuard, expedienteGuard],
                data: { breadcrumb: 'miga-pan.historico' },
              },
            ],
          },
          {
            path: 'dnda',
            data: { breadcrumb: 'DNDA' },
            children: [
              {
                path: ':expedienteId/:usuarioId',
                component: DetalleDndaComponent,
                canActivate: [authGuard, expedienteGuard],
                data: { breadcrumb: 'miga-pan.historico' },
              },
            ],
          },
          {
            path: 'sic',
            data: { breadcrumb: 'SIC' },
            children: [
              {
                path: ':expedienteId/:usuarioId',
                component: DetalleSicComponent,
                canActivate: [authGuard, expedienteGuard],
                data: { breadcrumb: 'miga-pan.historico' },
              },
            ],
          },
          {
            path: 'dimar',
            data: { breadcrumb: 'DIMAR' },
            children: [
              {
                path: ':expedienteId/:usuarioId',
                component: DetalleDimarComponent,
                canActivate: [authGuard, expedienteGuard],
                data: { breadcrumb: 'miga-pan.historico' },
              },
            ],
          },
          {
            path: 'ica',
            data: { breadcrumb: 'ICA' },
            children: [
              {
                path: ':expedienteId/:usuarioId',
                component: DetalleIcaComponent,
                canActivate: [authGuard, expedienteGuard],
                data: { breadcrumb: 'miga-pan.historico' },
              },
            ],
          },
          {
            path: 'supersalud',
            data: { breadcrumb: 'Supersalud' },
            children: [
              {
                path: ':expedienteId/:usuarioId',
                component: DetalleSupersaludComponent,
                canActivate: [authGuard, expedienteGuard],
                data: { breadcrumb: 'miga-pan.historico' },
              },
            ],
          },
          {
            path: 'ssm',
            data: { breadcrumb: 'Supersociedades Mercantiles' },
            children: [
              {
                path: ':expedienteId/:usuarioId',
                component: DetalleSupersociedadesMercantilesComponent,
                canActivate: [authGuard, expedienteGuard],
                data: { breadcrumb: 'miga-pan.historico' },
              },
            ],
          },
          {
            path: 'insolvencia',
            data: { breadcrumb: 'Supersociedades insolvencia' },
            component: DetalleSupersociedadesInsolvenciaComponent
          },
          {
            path: 'ssi',
            data: { breadcrumb: 'Supersociedades insolvencia' },
            children: [
              {
                path: ':expedienteId/:usuarioId',
                component: DetalleProcesoInsolvenciaComponent,
                canActivate: [authGuard, expedienteGuard],
                data: { breadcrumb: 'miga-pan.historico' },
              },
            ],
          },
          {
            path: ':entidadId',
            data: { breadcrumb: 'miga-pan.entidad' },
            children: [
              {
                path: ':avance-procesal',
                data: { breadcrumb: 'miga-pan.avance-procesal' },
                children: [
                  {
                    path: ':expedienteId',
                    canActivate: [authGuard, expedienteGuard],
                    data: { breadcrumb: 'miga-pan.historico' },
                    children: [
                      {
                        path: '',
                        component: AvanceProcesalComponent,
                        data: { breadcrumb: 'miga-pan.crear-avance-procesal' },
                      },
                      {
                        path: 'solicitudes',
                        data: { breadcrumb: 'miga-pan.solicitudes' },
                        children: [
                          {
                            path: '',
                            component: DetalleAvanceProcesalComponent,
                            canActivate: [authGuard, expedienteGuard],
                            data: { breadcrumb: 'miga-pan.detalle-solicitudes' },
                          },
                          {
                            path: 'anexos',
                            children: [
                              {
                                path: ':avanceProcesalId',
                                data: { breadcrumb: 'miga-pan.anexos' },
                                component: AnexosAvanceProcesalComponent,
                                canActivate: [authGuard, expedienteGuard],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        path: 'metricas-entidad',
        component: MetricasEntidadComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.metricas' },
      },

      {
        path: 'parametrizacion-entidades',
        component: ParametrizacionEntidadesComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.entidades' },
      },
      {
        path: 'gestion-eventos-entidad',
        component: GestionEventosEntidadComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.eventos-entidad' },
      },
      {
        path: 'tablero-resumen',
        component: TableroResumenCiudadanoComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.tablero-resumen' },
      },
      {
        path: 'procesos',
        data: { breadcrumb: 'miga-pan.proceso' },
        children: [
          {
            path: '',
            redirectTo: 'resumen',
            pathMatch: 'full'
          },
          {
            path: 'resumen',
            component: ResumenGeneralComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'miga-pan.resumen-general' },
          },

          {
            path: 'sic',
            component: ProcesosSicComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'SIC' },
          },
          {
            path: 'dimar',
            component: ProcesosDimarComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'DIMAR' },
          },
          {
            path: 'dnda',
            component: ProcesosDndaComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'DNDA' },
          },
          {
            path: 'supersalud',
            component: ProcesosSupersaludComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'SUPERSALUD' },
          },
          {
            path: 'superfinanciera',
            component: ProcesosSuperfinancieraComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'SUPERFINANCIERA' },
          },
          {
            path: 'ica',
            component: ProcesosIcaComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'ICA' },
          },
          {
            path: 'supersociedades_mercantiles',
            component: ProcesosSupersociedadesMercantilesComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'SUPERSOCIEDADES' },
          },
          {
            path: 'supersociedades_insolvencia',
            component: ProcesosSupersociedadesInsolvenciaComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'SUPERSOCIEDADES' },
          },
        ],
      },
      {
        path: 'administrar-cuenta',
        data: { breadcrumb: 'miga-pan.administrar-cuenta' },
        children: [
          {
            path: '',
            component: ConfigurarCuentaComponent,
            data: { breadcrumb: 'miga-pan.administracion-cuenta' },
            canActivate: [authGuard],
          },
          {
            path: 'cambiar-contrasenia',
            component: CambiarContraseniaComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'miga-pan.cambiar-contrasenia' },
          },
        ],
      },
      {
        path: 'administrar-cuenta-administrativa',
        component: ConfigurarCuentaAdministrativaComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.administrar-cuenta-administrativa' },
      },
      {
        path: 'preguntas-frecuentes',
        component: PreguntasFrecuentesComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.preguntas-frecuentes' },
      },
      {
        path: 'administracion-funcional',
        data: { breadcrumb: 'miga-pan.administracion-funcional' },
        children: [
          {
            path: 'visualizar-administrador',
            component: VisualizarAdministradorComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'miga-pan.visualizar-administrador' },
          },
        ],
      },
      {
        path: 'administracion-usuarios',
        data: { breadcrumb: 'miga-pan.administracion-usuarios' },
        children: [
          {
            path: 'lista-administradores',
            component: ListaAdministradoresComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'miga-pan.lista-administradores' },
          },
          {
            path: 'crear-admin-lider',
            component: CrearAdministradorComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'miga-pan.crear-admin-lider' },
          },
          {
            path: 'crear-admin-funcional/:idEntidad',
            component: CrearAdministradorComponent,
            canActivate: [authGuard, admFuncionalLiderGuard],
            data: { breadcrumb: 'miga-pan.crear-admin-funcional' },
          },
          {
            path: 'modificar-admin-lider/:idUsuario',
            component: ModificarAdministradorComponent,
            canActivate: [authGuard],
            data: { breadcrumb: 'miga-pan.modificar-admin-lider' },
          },
          {
            path: 'modificar-admin-funcional/:idUsuario',
            component: ModificarAdministradorComponent,
            canActivate: [authGuard, admFuncionalLiderGuard],
            data: { breadcrumb: 'miga-pan.modificar-admin-funcional' },
          },
        ],
      },
      {
        path: 'observatorio-de-justicia',
        loadChildren: () =>
          import('./modules/observatorio/observatorio-routing.module').then(
            m => m.ObservatorioRoutingModule
          ),
        data: { breadcrumb: 'Observatorio de Justicia' },
      },
      {
        path: 'formularios-enviados',
        component: FormulariosEnviadosComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.formularios-enviados' },
      },
      {
        path: 'justino',
        loadChildren: () =>
          import('./modules/justino/justino-routing.module').then(
            m => m.JustinoRoutingModule
          ),
        canActivate: [authGuard],
        data: { breadcrumb: 'Justino' },
      },
      {
        path: 'cargue-manual',
        component: GestionManualComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.cargue-manual' },
      },
      {
        path: 'gestion-encuestas',
        component: AdministracionEncuestasComponent,
        canActivate: [authGuard],
        data: { breadcrumb: 'miga-pan.administrar-encuesta' },
      },
      {
        path: 'empresa',
        data: { breadcrumb: 'miga-pan.empresa' },
        children: [
          {
            path: 'gestion-usuarios',
            data: { breadcrumb: 'miga-pan.usuarios-gestores' },
            component: UsuariosGestoresComponent,
            canActivate: [authGuard]
          }
        ]
      },
      {
        path: 'administracion-solicitudes-PJ',
        component: AdministracionSolicitudesPJComponent
      }
    ]
  },

  {
    path: '**',
    redirectTo: '',
    data: {
      breadcrumb: 'miga-pan.inicio',
      roles: [
        'Superadministrador',
        'Administrador Lider',
        'Administrador Funcional',
      ],
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload',
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
